import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table table-striped my-4" }
const _hoisted_2 = { class: "thead-dark" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "hide-in-print icon icon-navigation_pfeil_unten",
  "aria-hidden": "true"
}
const _hoisted_5 = {
  key: 1,
  class: "hide-in-print icon icon-navigation_pfeil_oben",
  "aria-hidden": "true"
}
const _hoisted_6 = {
  key: 2,
  class: "hide-in-print icon icon-filter",
  "aria-hidden": "true"
}
const _hoisted_7 = {
  key: 0,
  class: "hide-in-print table-width-100"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "hide-in-print table-width-100"
}
const _hoisted_10 = {
  key: 0,
  class: "d-flex justify-content-center aling-items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_default = _resolveComponent("link-default")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", _hoisted_2, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortColumns(), (sortColumn, index) => {
          return (_openBlock(), _createElementBlock("th", {
            key: 'sort-column-' + index,
            class: "p-0"
          }, [
            _createElementVNode("button", {
              onClick: _withModifiers(($event: any) => (_ctx.sort(sortColumn)), ["prevent"]),
              class: "btn btn-table-sort"
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.reservations.sortColumns.' + sortColumn)), 1),
              (_ctx.sortOptions.column ===sortColumn && _ctx.sortOptions.sortOrder==='asc')
                ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                : _createCommentVNode("", true),
              (_ctx.sortOptions.column ===sortColumn && _ctx.sortOptions.sortOrder==='desc')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                : _createCommentVNode("", true),
              (_ctx.sortOptions.column !==sortColumn)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                : _createCommentVNode("", true)
            ], 8, _hoisted_3)
          ]))
        }), 128)),
        (_ctx.searchType !== 'CANCELLED')
          ? (_openBlock(), _createElementBlock("th", _hoisted_7, _toDisplayString(_ctx.$t('views.reservations.action')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tickets, (ticket, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          _createElementVNode("td", null, _toDisplayString(_ctx.shortRoomName(ticket.roomName)), 1),
          _createElementVNode("td", null, [
            _createTextVNode(_toDisplayString(ticket.lastName), 1),
            (ticket.lastName && ticket.firstName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, ","))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(ticket.firstName), 1)
          ]),
          _createElementVNode("td", null, _toDisplayString(ticket.organisation), 1),
          _createElementVNode("td", null, _toDisplayString(ticket.email), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.formatTicketTime(ticket)), 1),
          (_ctx.searchType !== 'CANCELLED')
            ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                (ticket.lastName && ticket.firstName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_ctx.isEditable(ticket))
                        ? (_openBlock(), _createBlock(_component_link_default, {
                            key: 0,
                            i18nMessage: "common.ticketEdit",
                            to: { name: 'admin-reservation-edit', params: { id: ticket.id }, query: { 'fromSearch': 'y' } },
                            iconOnly: true,
                            iconClass: "icon-editieren",
                            class: "d-block align-self-center"
                          }, null, 8, ["to"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}